import { Box, Dialog, Typography, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import IconButton from '../IconButton'
import { FC } from 'react'

const StyledModal = styled(Box)(({ theme }) => ({
    backgroundColor: '#f7f8fa',
    borderRadius: '0.8rem',
    boxShadow: '0 0 1.3rem 0 rgba(0, 0, 0, 0.15)',
    padding: 0,
    '&:focus': {
        outline: 'none',
    },
}))

const ModalHeader = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '12%',
    padding: '1.6rem 0',
})

const CloseIconWrapper = styled(Box)({
    display: 'flex',
    marginRight: '-1.6rem',
    marginTop: '-1.6rem',
    height: '1rem',
})

const ModalTitle = styled(Typography)({
    fontSize: '2.4rem',
    fontWeight: 'normal',
    color: '#282828',
})

export const Modal: FC<any> = (props) => {
    const {
        open,
        onClose,
        title,
        header,
        children,
        maxWidth = 'md',
        fullScreen = false,
        fullWidth = true,
    } = props

    return (
        <Dialog
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            fullScreen={fullScreen}
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-labelledby={title}
            aria-describedby={title}
        >
            <StyledModal>
                {header ? (
                    header
                ) : (
                    <ModalHeader>
                        <ModalTitle>{title}</ModalTitle>
                        <CloseIconWrapper>
                            <IconButton onClick={onClose} size="large">
                                <Icon name="Close" color="#959598" />
                            </IconButton>
                        </CloseIconWrapper>
                    </ModalHeader>
                )}

                {children}
            </StyledModal>
        </Dialog>
    )
}
